<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Create New Notification</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel()">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout class="mb-3">
            <v-flex>
              <div class="subtitle-2 mb-1">
                Title
              </div>
              <v-text-field
                v-model="title"
                hide-details
                dense
                outlined
                placeholder="Title"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the message for the notification?
              </div>
              <v-textarea
                v-model="message"
                hide-details
                dense
                outlined
                placeholder="Message for the notification"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1 xs6">
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                return-object
                hide-details
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
            <v-flex class="ml-1 xs6">
              <div class="subtitle-2 mb-1">Radius</div>
              <v-select
                outlined
                dense
                return-object
                hide-details
                :items="[5000, 10000, 15000, 20000, 25000]"
                v-model="radius"
                item-text="name"
                placeholder="Radius"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                dense
                required
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import TimeAndDateSelectDialog from '@/modules/Content/components/TimeAndDateSelectDialog.vue';
export default {
  props: {
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
  },
  data() {
    return {
      dialog: false,
      message: '',
      title: '',
      region: {},
      scheduleDateDialog: false,
      scheduledAtDateField: '',
      scheduledAt: '',
      radius: 0,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    changeFields() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        data: {
          title: this.title,
          message: this.message,
          region: this.region,
          radius: this.radius,
        },

        type: 'notification',
        state: 'scheduled',
      };
    },
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
  },
  methods: {
    ...mapActions({
      getRegions: '$_home/getContent',
      getPushNotifications: '$_notification/getContent',
      createNewNotification: '$_notification/createNewContent',
    }),
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },

    cancel() {
      this.scheduledAtDateField = '';
      this.scheduledAt = '';
      this.message = '';
      this.region = {};
      this.radius = 0;
      this.title = '';
      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewNotification({
        details: this.changeFields,
        collection: this.collection,
        type: 'notification',
      }).then(() => {
        this.cancel();
        this.getPushNotifications({
          type: 'notification',
          collection: this.collection,
          mutation: 'updatePushNotifications',
        });
        this.dialog = false;
      });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style></style>
